import React, { useEffect, useState } from "react";
// import { toast } from "react-hot-toast";
import { Link, NavLink, useNavigate } from "react-router-dom";
// import logo from "../../src/Images/Neoo search logo white.png";
import logo from "../../src/Images/logo/white.png";
import { toast } from "react-hot-toast";
import HttpClient from "../utils/HttpClient";
import { useDispatch, useSelector } from "react-redux";
import { fetchBLMUsersData } from "../Redux/Slice/BLMSlice";

function Sidebar() {
  const { blmUsersCount } = useSelector((state) => state.blmUsers);
  const dispatch = useDispatch()
  const navigate = useNavigate();
  // const [blmUsersCount, setBlmUsersCount] = useState({
  //   pending: 0,
  //   approved: 0,
  //   paid: 0,
  //   suspended: 0,
  //   basic: 0,
  //   silver: 0,
  //   gold: 0,
  //   silverRequest: 0,
  //   goldRequest: 0

  // })
  // const getBLMUsersData = async () => {
  //   const res = await HttpClient.requestData("both-users", "GET", {});
  //   if (res && res?.status) {
  //     setBlmUsersCount({
  //       ...blmUsersCount,
  //       pending: res?.data.filter((item) => item?.status === "Pending").length || 0,
  //       approved: res?.data.filter((item) => item?.businessStatus && item?.status === "Active").length || 0,
  //       paid: res?.data.filter((item) => item?.paymentStatus).length || 0,
  //       suspended: res?.data.filter((item) => item?.suspendStatus).length || 0,
  //       basic: res?.data.filter((item) => item?.subscriptionData?._id === "66d89409094058c609c71832").length || 0,
  //       silver: res?.data.filter((item) => item?.subscriptionData?._id === "66d897a2094058c609c71836").length || 0,
  //       gold: res?.data.filter((item) => item?.subscriptionData?._id === "66d897d8094058c609c7183c").length || 0,
  //       silverRequest: res?.data.filter((item) => item?.planUpgradeRequested && item.upgradedSubscriptionId === "66d897a2094058c609c71836").length || 0,
  //       goldRequest: res?.data.filter((item) => item?.planUpgradeRequested && item.upgradedSubscriptionId === "66d897d8094058c609c7183c").length || 0

  //     })
  //     // setBlmUsersCount({ ...blmUsersCount, approved: res?.data.filter((item) => item.businessStatus && item.status === "Active").length || 0 })
  //     // setBlmUsersCount({ ...blmUsersCount, paid: res?.data.filter((item) => item.paymentStatus).length || 0 })
  //     // setBlmUsersCount({ ...blmUsersCount, suspended: res?.data.filter((item) => item.suspendStatus).length || 0 })
  //   } else {
  //   }

  // }
  useEffect(() => {
    dispatch(fetchBLMUsersData())
    // getBLMUsersData()
  }, [])
  // const handleClick = () => {
  //   if (document.querySelector("#DarkSwitch").checked) {
  //     document.body.classList.add("drakmode");
  //   } else {
  //     document.body.classList.remove("drakmode");
  //   }
  // };

  // const handlClick = () => {
  //   if (document.querySelector("#backbtnsidebar").click) {
  //     document.querySelector(".sidebarwrap").classList.remove("show");
  //   } else {
  //     document.querySelector(".sidebarwrap").classList.remove("show");
  //   }
  // };

  const handleLogOut = () => {
    // toast.success("Logout SuccessFull");
    localStorage.clear();
    navigate("/login");
  };
  return (
    <>
      <section className="sidebarwrap">
        <div className="top_area">
          <button id="backbtnsidebar">
            <i className="fa-solid fa-arrow-left"></i>
          </button>

          <div className="logo_area d-flex justify-content-center ">
            <div className="logo">
              {/* <img src={logo} className="img-fluid" alt="logo" /> */}
              {/* <h1 style={{ color: "#fff" }}>Logo</h1> */}
              <img
                src={logo}
                alt=""
                // style={{ width: "111px", height: "30px" }}
                className=""
              />
            </div>
          </div>
        </div>

        <div className="sidebar_menu">
          <ul className="nav Menu_Nav accordion" id="sidemenu">
            {/***Menu 1***/}
            <li className="menuline">
              <NavLink to="/" className="">
                <i className="fa-solid fa-bars"></i>
                <span>Dashboard</span>
              </NavLink>
            </li>

            {/***Homepage Background***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-homepage-background">
                <Link
                  to="/homepage-background"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-homepage-background"
                  aria-expanded="true"
                  aria-controls="sidemenu-homepage-background"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Background</span>
                </Link>
              </div>
              <div
                id="sidemenu-homepage-background"
                className="collapse"
                aria-labelledby="sidemenuhead-homepage-background"
                data-parent="#sidemenu"
              >
              </div>
            </li>

            {/***Menu 2***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead1">
                <Link
                  to="/type-of-company"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu1"
                  aria-expanded="true"
                  aria-controls="sidemenu1"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <div className=" d-flex flex-column ">
                    <span>Company Type </span>
                    {/* <span>   &nbsp;(main category) </span> */}
                  </div>
                </Link>
              </div>
              <div
                id="sidemenu1"
                className="collapse"
                aria-labelledby="sidemenuhead1"
                data-parent="#sidemenu"
              >
                {/* <ul className="Submenu">
                  <li>
                    <Link to="/type-of-company">
                      <i className="fa-solid fa-angles-right mr-2"></i>Add &
                      Manage Type of Company
                    </Link>
                  </li>
                </ul> */}
              </div>
            </li>
            {/***Menu 3***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead3">
                <Link
                  to="/type-of-services"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu3"
                  aria-expanded="true"
                  aria-controls="sidemenu3"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Services </span>
                </Link>
              </div>
              <div
                id="sidemenu3"
                className="collapse"
                aria-labelledby="sidemenuhead3"
                data-parent="#sidemenu"
              >
                {/* <ul className="Submenu">
                  <li>
                    <Link to="/type-of-services">
                      <i className="fa-solid fa-angles-right mr-2"></i>View
                      Categories
                    </Link>
                  </li>
               
                </ul> */}
              </div>
            </li>
            {/***Menu 5***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead5">
                <Link
                  to="/profile-type"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu5"
                  aria-expanded="true"
                  aria-controls="sidemenu5"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Profile Type</span>
                </Link>
              </div>
              <div
                id="sidemenu5"
                className="collapse"
                aria-labelledby="sidemenuhead5"
                data-parent="#sidemenu"
              >
                {/* <ul className="Submenu">
                  <li>
                    <Link to="/view-payment-history">
                      <i className="fa-solid fa-angles-right mr-2"></i>View
                      Payment History
                    </Link>
                  </li>
                </ul> */}
              </div>
            </li>

            {/***Menu 2***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead2">
                <Link
                  to="/type-of-designation"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu2"
                  aria-expanded="true"
                  aria-controls="sidemenu2"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Designation</span>
                </Link>
              </div>
              <div
                id="sidemenu2"
                className="collapse"
                aria-labelledby="sidemenuhead2"
                data-parent="#sidemenu"
              >
                {/* <ul className="Submenu">
                  <li>
                    <Link to="/type-of-designation">
                      <i className="fa-solid fa-angles-right mr-2"></i>Add &
                      manage Designation
                    </Link>
                  </li>
                 
                </ul> */}
              </div>
            </li>

            {/***Menu 2 Keywords***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-keywords">
                <Link
                  to="/keywords"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-keywords"
                  aria-expanded="true"
                  aria-controls="sidemenu-keywords"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Keywords</span>
                </Link>
              </div>
              <div
                id="sidemenu-keywords"
                className="collapse"
                aria-labelledby="sidemenuhead-keywords"
                data-parent="#sidemenu"
              >
                {/* <ul className="Submenu">
                  <li>
                    <Link to="/type-of-designation">
                      <i className="fa-solid fa-angles-right mr-2"></i>Add &
                      manage Designation
                    </Link>
                  </li>
                 
                </ul> */}
              </div>
            </li>

            {/***Menu 2 Subscription Plans***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-subscription-plans">
                <Link
                  to="/subscription-plans"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-subscription-plans"
                  aria-expanded="true"
                  aria-controls="sidemenu-subscription-plans"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Subscription plans</span>
                </Link>
              </div>
              <div
                id="sidemenu-subscription-plans"
                className="collapse"
                aria-labelledby="sidemenuhead-subscription-plans"
                data-parent="#sidemenu"
              >
                {/* <ul className="Submenu">
                  <li>
                    <Link to="/type-of-designation">
                      <i className="fa-solid fa-angles-right mr-2"></i>Add &
                      manage Designation
                    </Link>
                  </li>
                 
                </ul> */}
              </div>
            </li>

            {/***Menu 2 SponsorAd***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-sponsor-ad">
                <Link
                  to="/sponsor-ad"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-sponsor-ad"
                  aria-expanded="true"
                  aria-controls="sidemenu-sponsor-ad"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Sponsor Ad</span>
                </Link>
              </div>
              <div
                id="sidemenu-sponsor-ad"
                className="collapse"
                aria-labelledby="sidemenuhead-sponsor-ad"
                data-parent="#sidemenu"
              >
              </div>
            </li>

            {/***Menu 4***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead4">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu4"
                  aria-expanded="true"
                  aria-controls="sidemenu4"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>User(Member)</span>
                </Link>
              </div>
              <div
                id="sidemenu4"
                className="collapse"
                aria-labelledby="sidemenuhead4"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <Link to="/add-user-form">
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      User(Member)
                    </Link>
                  </li>
                  <li>
                    <Link to="/view-user-data">
                      <i className="fa-solid fa-angles-right mr-2"></i>View User
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
            {/***Menu 6***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead6">
                <Link
                  // to="/non-member"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu6"
                  aria-expanded="true"
                  aria-controls="sidemenu6"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>User(Non Member)</span>
                </Link>
              </div>
              <div
                id="sidemenu6"
                className="collapse"
                aria-labelledby="sidemenuhead6"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <Link to="/non-member">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Non Member List
                    </Link>
                  </li>
                  <li>
                    <Link to="/non-member-request-upgradation">
                      <i className="fa-solid fa-angles-right mr-2"></i>Request
                      For Upgradation
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {/***Menu 10: Business Listing***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead10">
                <Link
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu10"
                  aria-expanded="true"
                  aria-controls="sidemenu10"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Business Listing</span>
                </Link>
              </div>
              <div
                id="sidemenu10"
                className="collapse"
                aria-labelledby="sidemenuhead10"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  {/* <li>
                    <Link to="/member-business-list">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Approved Member User X
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link to="/non-member-business-list">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Approved BLM User (15)
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link to="/member-business-list-pending">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Pending Member User X
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link to="/non-member-business-list-pending">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Pendig BLM User (20)
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/pending-blm-users">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Pendig BLM User ({blmUsersCount?.pending})
                    </Link>
                  </li>
                  <li>
                    <Link to="/approved-blm-users">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Approved BLM User ({blmUsersCount?.approved})
                    </Link>
                  </li>
                  <li>
                    <Link to="/paid-blm-users">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Paid BLM User ({blmUsersCount?.paid})
                    </Link>
                  </li>
                  <li>
                    <Link to="/suspended-blm-users">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Suspended User ({blmUsersCount?.suspended})
                    </Link>
                  </li>

                </ul>
              </div>
            </li>

            {/***Menu 10: BLM Users Listing***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-blm-users">
                <Link
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-blm-users"
                  aria-expanded="true"
                  aria-controls="sidemenu-blm-users"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>BLM Users</span>
                </Link>
              </div>
              <div
                id="sidemenu-blm-users"
                className="collapse"
                aria-labelledby="sidemenuhead-blm-users"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">

                  <li>
                    <Link to="/basic-blm-users">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Basic BLM User ({blmUsersCount?.basic})
                    </Link>
                  </li>
                  <li>
                    <Link to="/silver-blm-users">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Silver BLM User ({blmUsersCount?.silver})
                    </Link>
                  </li>
                  <li>
                    <Link to="/gold-blm-users">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Gold BLM User ({blmUsersCount?.gold})
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {/***Menu 10: BLM Upgrade Request***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-blm-upgrade">
                <Link
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-blm-upgrade"
                  aria-expanded="true"
                  aria-controls="sidemenu-blm-upgrade"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>BLM Upgrade</span>
                </Link>
              </div>
              <div
                id="sidemenu-blm-upgrade"
                className="collapse"
                aria-labelledby="sidemenuhead-blm-upgrade"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <Link to="/silver-requested-blm-users">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      BLM Silver Plan Request ({blmUsersCount?.silverRequest})
                    </Link>
                  </li>
                  <li>
                    <Link to="/gold-requested-blm-users">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      BLM Gold Plan Request ({blmUsersCount?.goldRequest})
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {/***Menu 7***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead7">
                <Link
                  to="/offer-category"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu7"
                  aria-expanded="true"
                  aria-controls="sidemenu7"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Offer Category</span>
                </Link>
              </div>
              {/* <div
                id="sidemenu7"
                className="collapse"
                aria-labelledby="sidemenuhead7"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <Link to="/non-member">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Non Member List
                    </Link>
                  </li>
                  <li>
                    <Link to="/non-member-request-upgradation">
                      <i className="fa-solid fa-angles-right mr-2"></i>Request For Upgradation
                    </Link>
                  </li>
                </ul>
              </div> */}
            </li>

            {/***Menu 9***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead9">
                <Link
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu8"
                  aria-expanded="true"
                  aria-controls="sidemenu8"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Offers</span>
                </Link>
              </div>
              <div
                id="sidemenu8"
                className="collapse"
                aria-labelledby="sidemenuhead8"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <Link to="/offers">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Add Offer
                    </Link>
                  </li>
                  <li>
                    <Link to="/manage-offers">
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Offer
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
            {/***Menu 8***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead9">
                <Link
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu9"
                  aria-expanded="true"
                  aria-controls="sidemenu9"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Message</span>
                </Link>
              </div>
              <div
                id="sidemenu9"
                className="collapse"
                aria-labelledby="sidemenuhead9"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <Link to="/message-categories">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Categories
                    </Link>
                  </li>
                  <li>
                    <Link to="/message-user">
                      <i className="fa-solid fa-angles-right mr-2"></i>Users
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
            {/***Menu 09***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead09">
                <Link
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu09"
                  aria-expanded="true"
                  aria-controls="sidemenu09"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Promo Code</span>
                </Link>
              </div>
              <div
                id="sidemenu09"
                className="collapse"
                aria-labelledby="sidemenuhead09"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <Link to="/promo-code">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Manage Codes
                    </Link>
                  </li>

                </ul>
              </div>
            </li>
            {/***Menu Posts***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-posts">
                <Link
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-posts"
                  aria-expanded="true"
                  aria-controls="sidemenu-posts"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Posts</span>
                </Link>
              </div>
              <div
                id="sidemenu-posts"
                className="collapse"
                aria-labelledby="sidemenuhead-posts"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <Link to="/posts">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Manage Posts
                    </Link>
                  </li>

                </ul>
              </div>
            </li>
            {/***Send message/updates***/}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-send-updates">
                <Link
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-send-updates"
                  aria-expanded="true"
                  aria-controls="sidemenu-send-updates"
                >
                  <i className="fa-regular fa-address-card"></i>
                  <span>Send Updates</span>
                </Link>
              </div>
              <div
                id="sidemenu-send-updates"
                className="collapse"
                aria-labelledby="sidemenuhead-send-updates"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <Link to="/send-message-to-members">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      To members
                    </Link>
                  </li>
                  <li>
                    <Link to="/send-message-to-nonmembers">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      To non-members
                    </Link>
                  </li>
                  <li>
                    <Link to="/send-message-to-blm-members">
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      To BLM members
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

          </ul>

          <ul className="nav Account_Nav">
            <div style={{ width: "100%" }} onClick={handleLogOut}>
              <Link>
                <i className="fa-solid fa-right-from-bracket mr-2"></i>
                <span>Logout</span>
              </Link>
            </div>
          </ul>
        </div>
      </section>
    </>
  );
}

export default Sidebar;
